import axios from "axios"

export default () => {
  const token = document.getElementsByName("csrf-token")[0].getAttribute("content")
  axios.defaults.headers.common["X-CSRF-Token"] = token
}
